import { ShieldCheck } from "lucide-react";

/**
 * The one icon beside a course's refund line (`refundPolicyText_*`), wherever
 * the course page prints it: the hero, the sidebar and the plan comparison
 * (`docs/03` §6, `SITE-FIX01`). A shield in `emerald-700`, 16 px, aligned to
 * the first line of text.
 */
export function RefundLineIcon() {
  return <ShieldCheck aria-hidden className="mt-0.5 h-4 w-4 shrink-0 text-emerald-700" />;
}
